import type { IconName } from "@@/shared/icon-name";
import type { Translatable} from "@@/shared/translations/translation";
import { translation } from "@@/shared/translations/translation";
import { toObjectMap } from "@@/utilities/dictionary";
import { z } from "zod";

const contentAutoPageBlockLayoutTypes = ["auto", "hzScroll", "grid"] as const;
type ContentAutoPageBlockLayoutType =
    (typeof contentAutoPageBlockLayoutTypes)[number];
const contentAutoPageBlockLayoutType =
    toObjectMap<ContentAutoPageBlockLayoutType>([
        ...contentAutoPageBlockLayoutTypes,
    ]);

const contentAutoPageBlockLayoutTypeMeta: Record<
    ContentAutoPageBlockLayoutType,
    {
        iconName: IconName;
        name: Translatable;
    }
> = {
    auto: {
        iconName: "fa-wand-magic-sparkles",
        name: translation({
            sv: "Auto",
            en: "Auto",
        }),
    },
    grid: {
        iconName: "fa-grid",
        name: translation({
            sv: "Rutnät",
            en: "Grid",
        }),
    },
    hzScroll: {
        iconName: "fa-left-right",
        name: translation({
            sv: "Horisontell skroll",
            en: "Horizontal scroll",
        }),
    },
};
const contentAutoPageBlockLayoutTypeZodSchema = z.enum(
    contentAutoPageBlockLayoutTypes,
);

export {
    contentAutoPageBlockLayoutType,
    contentAutoPageBlockLayoutTypeMeta,
    contentAutoPageBlockLayoutTypeZodSchema,
};
export type { ContentAutoPageBlockLayoutType };
